<template lang="pug">
	div

		div.mb-3(v-if="!userCreated")
			p.text-muted.my-1 Создайте аккаунт участника если его нет в системе
			p.text-muted.my-1
				| Проверить зарегистрирован ли человек можно
				|
				a(href="#!" @click="_setTab(0)") здесь

		// Create user form
		formCreateUser(v-if="!userCreated" :_cbOK="createUserCbOK")

		div(v-if="userCreated")
			div.my-2 Вы только что создали пользователя:

			div.d-flex.align-items-center
				img(:src="'/img/placeholders/avatar.png'" width="50" style="border-radius:50%;")
				div.ml-2
					div {{ users.post.data.first_name }} {{ users.post.data.last_name }}
					small {{ users.post.data.email }}

			div.my-2 Хотите добавить его в группу?

		// Create Participant form
		div(v-if="userCreated")
			b-alert.mt-3(v-if="_event.extra_data.length" show variant="warning") Чтобы добавить пользователя в группу выберите параметры его участия в форме ниже
			FormPpnt( :_event="_event" :_msgOK="'Участник успешно добавлен в группу!'" :_cbOK="createPpntCbOK" :_htmlFormModel="_event.use_price ? regFormModel : []" :_userID="page.participant.regUserID" :_ppntID="myParticipant.data.id")

</template>

<script>
	import { mapState } from 'vuex';

	import FormPpnt from '../../../components/FormPpnt'
	import formCreateUser from '../forms/formCreateUser'

	let regFormModel = [
		{name:"promo_code", placeholder:"Промокод", type:"text" },
	];
	export default {
		name: 'createAccountTab',
		props:['_ppnt','_setTab','_event', '_cbOK'],
		components: {
			FormPpnt,
			formCreateUser,
		},
		data: () => ({
			regFormModel,
			userCreated: false,
		}),
		computed: {
			...mapState(['page', 'users', 'myParticipant']),
		},
		methods: {
			createPpntCbOK(){
				this.$store.dispatch('getMyParticipant', { id:this.myParticipant.data.id });
				setTimeout(()=>{
					this.$bvModal.hide('addExtraParticipantModal');
					this.userCreated = false;
					this.$store.commit('clearUsersPost');
				}, 1000);
			},
			createUserCbOK(){
				this.$store.commit('setRegUserID', this.users.post.data.id);
				setTimeout(()=> {
					this.userCreated = true;
				}, 1000);
			},
		}
	}
</script>
